import React, { useMemo } from 'react'
import { H6, Overline } from '@fs/zion-ui'
import { FormCheckbox, useWatch, useZionFormContext } from '@fs/zion-form'
import { useTranslation } from 'react-i18next'

import {
  getMostRecentFieldValue,
  getNestedSubelementsByType,
  getPersonGivenName,
  getPersonName,
  getPrimaryRelationshipText,
  getRelationshipToPrimaryPersonDisplayLabel,
  getRelationshipToPrimaryPersonText,
  useSlsStateContext,
} from '@fs/zion-sls'
import FieldWrapper from '../../../../../components/generic/panels/uiHelpers/FieldWrapper'
import { useR2StateContext } from '../../../../../providers/r2Provider/R2Context'
import { getSyncedCheckboxProps } from './SharedFieldUtils'

const SharedFieldPersonCheckbox = ({ person, lockSharedSuperEl, sharedElement, record, newValue }) => {
  const state = useSlsStateContext()
  const r2State = useR2StateContext()
  const [t] = useTranslation()
  const formMethods = useZionFormContext()
  // Watch only the specific field for this checkbox to reduce unnecessary re-renders
  const personFieldValue = useWatch({ name: person.id })
  const isSelectedPerson = r2State.selectedPersonId === person.id
  const relationshipToHead = getNestedSubelementsByType(person, 'RELATIONSHIP_TO_HEAD')?.[0]
  const relationshipToHeadValue = getMostRecentFieldValue(relationshipToHead)
  const primaryRelationshipLabel = getRelationshipToPrimaryPersonDisplayLabel(person, state.types, record) || ''
  const relationshipText = getRelationshipToPrimaryPersonText(person, state.types, record, t) || ''
  const primaryRelationshipText = getPrimaryRelationshipText(primaryRelationshipLabel, relationshipText)

  const personFullName = useMemo(
    () =>
      isSelectedPerson && sharedElement.fieldType === 'NAME_SURN'
        ? `${getPersonGivenName(person)} ${newValue}`
        : getPersonName({ person }),
    [isSelectedPerson, newValue, person, sharedElement.fieldType]
  )
  // Use the synchronized checkbox utility to handle duplicate checkboxes
  const { checked, onChange } = getSyncedCheckboxProps(formMethods, person.id, personFieldValue)

  return (
    <FieldWrapper>
      <H6>
        <Overline>{primaryRelationshipText}</Overline>
      </H6>

      <FormCheckbox
        disabled={lockSharedSuperEl || isSelectedPerson}
        name={person.id}
        value={person.id}
        checked={checked}
        onChange={onChange}
        label={`${personFullName} ${relationshipToHeadValue ? `(${relationshipToHeadValue})` : ''}`}
      />
    </FieldWrapper>
  )
}

export default SharedFieldPersonCheckbox
